import {
  signOut
} from "firebase/auth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import i18n from 'i18next';
import {auth} from './firebaseConfig';

const TokenRetrieve = async () => {
  if(auth.currentUser){
    const token = await auth.currentUser.getIdToken();
    return token;
  }else{
    return null;
  }
}

const GetAllItems = async (controller, i, name = null) => {
    const url = `${controller}BE/GetAll?i=${i}${name ? "&n=" + name : ""}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8"
      },
    });

    if (!response.ok) {
      // throw new Error(`Errore HTTP! Status: ${response.status}`);
      return null;
    }

    const data = await response.json();

    if (data) {
      return data;
    }
  return null;
};

const GetAllItemsP = async (controller) => {
  const token = await TokenRetrieve();
  if (token !== "" && token) {
  const url = `${controller}BE/GetAll`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`
    },
  });

  if (!response.ok) {
    // throw new Error(`Errore HTTP! Status: ${response.status}`);
    return null;
  }

  const data = await response.json();

  if (data) {
    return data;
  }
}
return null;
};

const GetById = async (controller, id) => {
  const token = await TokenRetrieve();
  if (token !== "" && token) {
    const url = `${controller}BE/GetById?id=${id}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      // throw new Error(`Errore HTTP! Status: ${response.status}`);
      return null;
    }

    const data = await response.json();

    if (data) {
      return data;
    }
  }
  return null;
};

const GetUserByUid = async (controller, uid) => {
  try{
    const token = await TokenRetrieve();
    if (token !== "" && token) {
      const url = `${controller}BE/GetByUid?uid=${uid}`;
  
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        return null
      }
  
      const data = await response.json();
  
      if (data) {
        return data;
      }
    }
  }
  catch{
    return null;
  }
  
};

const GetUserByEmail = async (controller, email) => {
  try{
    const token = await TokenRetrieve();
    if (token !== "" && token) {
      const url = `${controller}BE/GetByEmail?email=${email}`;
  
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        // throw new Error(`Errore HTTP! Status: ${response.status}`);
        return null;
      }
  
      const data = await response.json();
  
      if (data) {
        return data;
      }
    }
  }
  catch {
    return null;
  }
};

const AddItem = async (controller, newItem) => {
  try {
    const token = await TokenRetrieve();

    if (!token) {
      return null;
    }

    const url = `${controller}BE/Add`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newItem),
    });

    if (!response.ok) {
      if(response.statusText === "Bad Request" || response.statusText === "Conflict"){
        const error = await response.json();
        toast.error(i18n.t(error));
      }
      else{
        toast.error(i18n.t("ToastErrorCreated"));
      }
      
      return null;
    }
    else{
      const data = await response.json();
      toast.success(i18n.t("ToastSuccessCreated"));
      return data;
    }
  } catch (error) {
    toast.error(i18n.t("ToastErrorCreated"));
    return null;
  }
};

const UpdateItem = async (controller, updatedItem, pageName = "") => {
  try{
    const token = await TokenRetrieve();
    let item;
    if(pageName !== ""){
      item = {
        id: null,
        pageContent: updatedItem,
        name: pageName
      }
    }
    else {
      item = updatedItem;
    }
    if (token !== "" && token) {
      const url = `${controller}BE/Update`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(item),
      });

      if (!response.ok) {
        if(response.statusText === "Bad Request" || response.statusText === "Conflict"){
          const error = await response.json();
          toast.error(i18n.t(error));
        }
        else{
          toast.error(i18n.t("ToastErrorUpdated"));
        }
        return null;
      }

      const data = await response.json();

      if (data) {
        toast.success(i18n.t("ToastSuccessUpdated"));
        return data;
      }
    }
  } catch (error) {
    toast.error(i18n.t("ToastErrorUpdated"));
    return null;
  }
};

const DeleteItem = async (controller, id) => {
  const token = await TokenRetrieve();
  if (token !== "" && token) {
    const url = `${controller}BE/Delete`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(id),
    });

    if (!response.ok) {
      toast.error(i18n.t("ToastErrorDelete"));
      return null;
    }

    const data = await response.json();

    if (data) {
      toast.success(i18n.t("ToastSuccessDelete"));
      return data;
    }
  }
  return null;
};

const GetAllAvailableProperties = async (ids, checkIn, checkOut) => {
  if((ids && ids.length > 0) && checkIn && checkOut){
    const url = "PropertyBE/GetAllAvailableProperties";

      const item = {
        ids: ids,
        checkIn: FormatDate(new Date(checkIn)),
        checkOut: FormatDate(new Date(checkOut)),
      };

   const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(item),
    });
    
    const data = await response.json();

    if (data) {
      return data;
    }
  }

  
  return null;
};

const GetAvailabilityById = async (id, checkIn, checkOut) => {
  if(id){
   const url = `PropertyBE/GetAvailabilityById`;

    const item = {
      id: id,
      checkIn: checkIn ? FormatDate(new Date(checkIn)) : null,
      checkOut: checkOut ? FormatDate(new Date(checkOut)) : null,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(item),
    });

    if (!response.ok) {
      // throw new Error(`Errore HTTP! Status: ${response.status}`);
      return null;    
    }

    const data = await response.json();

    if (data) {
      return data;
    }
  }
  return null;
};

const CheckMinNights = async (id, checkIn) => {
  if(id){
   const url = `PropertyBE/CheckMinNights`;

    const item = {
      id: id,
      checkIn: checkIn ? FormatDate(new Date(checkIn)) : null,
    };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(item),
    });

    if (!response.ok) {
      // throw new Error(`Errore HTTP! Status: ${response.status}`);
      return null;    
    }

    const data = await response.json();

    if (data) {
      return data;
    }
  }
  return null;
};


const FormatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const logout = async () => {
  return await signOut(auth).then(window.location.replace('/'));
};

const generateBlobUrls = (attachments) => {
  const updatedAttachments = attachments.map((attachment) => {
    const byteCharacters = atob(attachment.base64);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: "application/octet-stream" });
    const objectUrl = URL.createObjectURL(blob);

    return {
      ...attachment,
      objectUrl: objectUrl,
    };
  });

  return updatedAttachments;
}

export {
  GetAllItems,
  GetAllItemsP,
  GetById,
  GetUserByUid,
  GetUserByEmail,
  AddItem,
  UpdateItem,
  DeleteItem,
  GetAllAvailableProperties,
  GetAvailabilityById,
  CheckMinNights,
  logout,
  generateBlobUrls,
  FormatDate
};